import React, { useId } from "react";
import { PermissionScopeOption } from "../../../../../interfaces";
import { useRolePermissionsContext } from "../../../../../context/RolePermissionsContext";

type PermissionScopeProps = {
    scope: PermissionScopeOption[];
    moduleCode: string;
    actionCode: number;
    isChildActive: boolean;
    className?: string;
};

const PermissionScope: React.FC<PermissionScopeProps> = ({
    scope,
    moduleCode,
    actionCode,
    isChildActive,
    className,
}) => {
    const groupName = useId();
    const { onChangePermissionScope, mode } = useRolePermissionsContext();
    const isViewMode = mode === "view";
    const activeScope = scope.find((option) => option.isActive);

    return (
        <div className={`${isViewMode ? "py-2" : "mt-2"} ${className ? className : "ms-4"}`}>
            {isViewMode ? (
                <p className={"mb-0"}>
                    <i className="bi bi-dash me-2"></i>
                    {activeScope?.label}
                </p>
            ) : (
                <>
                    {scope.map((option) => (
                        <div key={option.value} className="form-check d-flex align-items-center mb-2">
                            <input
                                type="radio"
                                className="form-check-input mt-0 me-2"
                                name={groupName}
                                id={`${groupName}-${option.value}`}
                                checked={option.isActive}
                                disabled={!isChildActive}
                                onChange={() => {
                                    onChangePermissionScope(moduleCode, actionCode, option.value);
                                }}
                            />

                            <label htmlFor={`${groupName}-${option.value}`} className="form-check-label mb-0">
                                {option.label}
                            </label>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default React.memo(PermissionScope);
